import { createFileRoute, redirect } from '@tanstack/react-router';
import { billingSearchOf } from '../screens/company/billing-search';

/**
 * The Billing group opens on Plan and credits. Stripe, the emails and the bell still send people to
 * `/settings/billing` (`CheckoutEndpoints.BillingUrl`, `CreditAlertEmail`, `NotificationWriter`), so
 * what the address carries back from paying by card goes along.
 */
export const Route = createFileRoute('/t/$tenant/settings/billing/')({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/t/$tenant/settings/billing/plan',
      params: { tenant: params.tenant },
      search: billingSearchOf(search),
      replace: true,
    });
  },
});
